module.exports = __webpack_public_path__ + "static/media/email-gray.2b3521bc.svg";